import React, { Component } from 'react';
import Progress from 'react-progressbar'
import Popup from 'reactjs-popup';

import { CardRadio } from "./common/CardRadio"
import { Card } from "./common/Card"

export class AssessmentSteps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSelected: this.props.state.AssessmentResults[this.props.state.processSteps] ? this.props.state.AssessmentResults[this.props.state.processSteps] : "0",
        }
    }
    handleSave = () => {
        this.props.handleSave(this.state)
        let currentSelected = this.props.state.AssessmentResults[this.props.state.processSteps + 1] ? this.props.state.AssessmentResults[this.props.state.processSteps + 1] : "0"
        this.setState({
            currentSelected: currentSelected
        })
    }
    handleBack = () => {
        this.props.handleBack(this.state)
        let currentSelected = this.props.state.AssessmentResults[this.props.state.processSteps - 1]
        this.setState({
            currentSelected: currentSelected
        })
    }
    onClick = (id) => {
        this.setState({ currentSelected: id })
        this.props.updateSelectedOption(id)
        setTimeout(() => {
            this.handleSave()
        }, 100);

    }
    urlLink = () => {
        let currentStep = this.props.state.currentStep - 1
        let currentSubStep = this.props.state.currentSubStep
        if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].explaination.indexOf("http") >= 0) {
            return (
                <a href={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].explaination} className="HelpTooltip" target="_blank">Read Help</a>
            )
        } else if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].explaination === "") {
            return (
                <a href={`${this.props.state.IndustryData[this.props.state.IndustryId - 1].localUrl}${this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].link}`} className="HelpTooltip" target="_blank">more info</a>)
        } else {
            return(
            <Popup
                trigger={<a className="HelpTooltip">Read Help</a>}
                on="click"
                position="top center"
                closeOnDocumentClick>
                <span>{this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].explaination}</span>
                </Popup>
            )
        }
    }
    render() {
        let HighPriorityIndicators
        let SaveButtonSection

        if (this.props.state.data.length > 0) {
            let currentStep = this.props.state.currentStep - 1
            let currentSubStep = this.props.state.currentSubStep
            if (this.props.state.data[currentStep].keyPerformanceIndicators.length <= 0) {
                this.props.moveToNext();
            }
            else {
                let optionSection
                let cardStyle = "OptionCard"
                if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal.length > 100 || this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal.length > 100 || this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal.length > 100) {
                    cardStyle = "OptionCard3"
                }
                else if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal.length > 50 || this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal.length > 50 || this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal.length > 50) {
                    cardStyle = "OptionCard2"
                }
                if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal) {
                    let randomorder = true
                    if (this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal.toString().lastIndexOf("<") === 0) {
                        randomorder = false;
                    }
                    
                    if (this.props.state.randomArray[this.props.state.processSteps] > 6.6 || randomorder === false) {
                        optionSection = (
                            <div className="row">
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal}
                                        onClick={this.onClick}
                                        id="1"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"  //changed all to greenoption now. 
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal}
                                        onClick={this.onClick}
                                        id="2"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal}
                                        onClick={this.onClick}
                                        id="3"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                            </div>
                        )
                    }
                    else if (this.props.state.randomArray[this.props.state.processSteps] > 3.3) {
                        optionSection = (
                            <div className="row">
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal}
                                        onClick={this.onClick}
                                        id="3"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal}
                                        onClick={this.onClick}
                                        id="1"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal}
                                        onClick={this.onClick}
                                        id="2"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                            </div>
                        )
                    }
                    else {
                        optionSection = (
                            <div className="row">
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].mettingGoal}
                                        onClick={this.onClick}
                                        id="2"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal}
                                        onClick={this.onClick}
                                        id="3"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <CardRadio
                                        label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal}
                                        onClick={this.onClick}
                                        id="1"
                                        currentSelected={this.state.currentSelected}
                                        optionClass="GreenOption"
                                        CardStyle={cardStyle}
                                        selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                    />
                                </div>
                            </div>
                        )
                    }
                }
                else {
                    optionSection = (
                        <div className="row">
                            <div className="col-sm-5 col-xs-12">
                                <CardRadio
                                    label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].exceedingGoal}
                                    onClick={this.onClick}
                                    id="1"
                                    currentSelected={this.state.currentSelected}
                                    optionClass="GreenOption"
                                    CardStyle={cardStyle}
                                    selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                />
                            </div>
                            <div className="col-sm-5 col-sm-offset-2 col-xs-12">
                                <CardRadio
                                    label={this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].notArchievingGoal}
                                    onClick={this.onClick}
                                    id="3"
                                    currentSelected={this.state.currentSelected}
                                    optionClass="GreenOption"
                                    CardStyle={cardStyle}
                                    selected={this.props.state.AssessmentResults[this.props.state.processSteps] !== "0" ? true : false}
                                />
                            </div>
                        </div>
                    )
                }

                HighPriorityIndicators = (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-sm-12 col-sm-offset-0 col-lg-8 col-lg-offset-2">
                                <div className="well">
                                    <h3><small>High Priority Indicator:</small><br />{this.props.state.data[currentStep].description}</h3></div>
                            </div>
                            <div className="col-sm-12 col-sm-offset-0 col-lg-8 col-lg-offset-2">
                                <h2><small>Metric / <abbr title="Key Performance Indicator">KPI</abbr></small><br />{this.props.state.data[currentStep].keyPerformanceIndicators[currentSubStep].description}</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col-xs-6 col-xs-offset-6`}>
                                {this.urlLink()}
                            </div>
                        </div>
                        {optionSection}
                    </React.Fragment>
                )

                SaveButtonSection = (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="col-xs-6">
                                    <button className="form-control btn btn-primary button_start"
                                        onClick={this.handleBack}
                                        type="button"
                                        aria-label="save">
                                        <span>Previous</span>
                                    </button>
                                </div>
                                <div className="col-xs-6">
                                    <button className="form-control btn btn-primary button_start"
                                        onClick={this.handleSave}
                                        type="button"
                                        aria-label="save"
                                        disabled={this.state.currentSelected > 0 ? "" : "disabled"}>
                                        <span> Next</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
        };
        let resetButton = (
            <a className="pull-right main-header-button" onClick={this.props.handleReset}><i className="glyphicon glyphicon-home"></i> Main</a>
        )

        return (
            <div className="panel panel-default main-panel" >
                <div className="panel-heading">
                    <span className="main-header"><i className="glyphicon glyphicon-road"></i> In Processing</span>
                    {resetButton}
                </div>
                <div className="panel-body main-body">
                    <div className="row"><div className="col-sm-12"><Progress completed={this.props.state.currentPercent} /></div></div>
                    steps {this.props.state.processSteps}/{this.props.state.processTotalSteps}
                    {HighPriorityIndicators}
                    {SaveButtonSection}
                </div>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/components/AssessmentSteps.js